var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderStepper2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_469_8376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.60938,
    y: 2.21875,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6068 20.0514C26.3858 20.0514 26.1738 20.1392 26.0175 20.2955C25.8612 20.4518 25.7734 20.6638 25.7734 20.8848V24.2181C25.7734 24.4391 25.8612 24.6511 26.0175 24.8074C26.1738 24.9636 26.3858 25.0514 26.6068 25.0514C26.8278 25.0514 27.0398 24.9636 27.196 24.8074C27.3523 24.6511 27.4401 24.4391 27.4401 24.2181V20.8848C27.4401 20.6638 27.3523 20.4518 27.196 20.2955C27.0398 20.1392 26.8278 20.0514 26.6068 20.0514ZM27.3734 27.2348C27.3552 27.1817 27.33 27.1312 27.2984 27.0848L27.1984 26.9598C27.0813 26.8441 26.9324 26.7658 26.7708 26.7347C26.6091 26.7035 26.4419 26.721 26.2901 26.7848C26.1891 26.827 26.0961 26.8862 26.0151 26.9598C25.9379 27.0376 25.8768 27.13 25.8353 27.2315C25.7938 27.333 25.7728 27.4418 25.7734 27.5514C25.7748 27.6603 25.7974 27.7679 25.8401 27.8681C25.8775 27.9715 25.9372 28.0654 26.015 28.1432C26.0928 28.221 26.1867 28.2807 26.2901 28.3181C26.3899 28.3622 26.4977 28.385 26.6068 28.385C26.7158 28.385 26.8237 28.3622 26.9234 28.3181C27.0269 28.2807 27.1208 28.221 27.1985 28.1432C27.2763 28.0654 27.336 27.9715 27.3734 27.8681C27.4161 27.7679 27.4388 27.6603 27.4401 27.5514C27.4442 27.496 27.4442 27.4402 27.4401 27.3848C27.4258 27.3316 27.4033 27.281 27.3734 27.2348ZM26.6068 15.8848C24.9586 15.8848 23.3474 16.3735 21.977 17.2892C20.6066 18.2049 19.5385 19.5064 18.9078 21.0291C18.277 22.5518 18.112 24.2273 18.4336 25.8439C18.7551 27.4604 19.5488 28.9452 20.7142 30.1107C21.8797 31.2761 23.3645 32.0698 24.981 32.3913C26.5975 32.7129 28.2731 32.5478 29.7958 31.9171C31.3185 31.2864 32.62 30.2183 33.5357 28.8479C34.4514 27.4774 34.9401 25.8663 34.9401 24.2181C34.9401 23.1238 34.7246 22.0401 34.3058 21.0291C33.887 20.018 33.2732 19.0994 32.4993 18.3255C31.7255 17.5517 30.8069 16.9379 29.7958 16.5191C28.7848 16.1003 27.7011 15.8848 26.6068 15.8848ZM26.6068 30.8848C25.2882 30.8848 23.9993 30.4938 22.903 29.7612C21.8066 29.0287 20.9522 27.9875 20.4476 26.7693C19.943 25.5511 19.811 24.2107 20.0682 22.9175C20.3254 21.6243 20.9604 20.4364 21.8927 19.5041C22.8251 18.5717 24.013 17.9368 25.3062 17.6795C26.5994 17.4223 27.9398 17.5543 29.158 18.0589C30.3762 18.5635 31.4174 19.418 32.1499 20.5143C32.8824 21.6106 33.2734 22.8996 33.2734 24.2181C33.2734 25.9862 32.5711 27.6819 31.3208 28.9321C30.0706 30.1824 28.3749 30.8848 26.6068 30.8848Z",
    fill: "#FF5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_469_8376",
    x: 0.609375,
    y: 0.21875,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.575 0 0 0 0 0.563021 0 0 0 0 0.563021 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_469_8376"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_469_8376",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderStepper2);
export default __webpack_public_path__ + "static/media/HeaderStepper2.80ee36aa8b3320a5dd3a34ece2cff03e.svg";
export { ForwardRef as ReactComponent };